import { apiGet, apiPost, apiPut, apiDelete } from './client';

export interface VenueSection {
  id?: string;
  name: string;
  price: number;
  seats: number;
}

export interface CreateVenueData {
  name: string;
  capacity: number;
  layout?: string;
  svgContent?: string;
  sections?: VenueSection[];
  address?: string;
  city?: string;
  country?: string;
  phone?: string;
  email?: string;
  website?: string;
  description?: string;
  parkingInfo?: string;
  accessibilityInfo?: string;
  googleMapsUrl?: string;
}

export interface UpdateVenueData extends Partial<CreateVenueData> {}

export interface Venue {
  id: string;
  name: string;
  capacity: number;
  layout: string;
  sections: VenueSection[];
  createdAt: string;
  updatedAt: string;
  adminId: string;
}

export const venuesApi = {
  getAllVenues: (): Promise<any> => {
    return apiGet('/venues');
  },

  getVenueById: (id: string): Promise<any> => {
    return apiGet(`/venues/${id}`);
  },

  createVenue: (data: CreateVenueData): Promise<any> => {
    return apiPost('/venues', data);
  },

  updateVenue: (id: string, data: UpdateVenueData): Promise<any> => {
    return apiPut(`/venues/${id}`, data);
  },

  deleteVenue: (id: string): Promise<any> => {
    return apiDelete(`/venues/${id}`);
  },
};

